import React from 'react';
import { CheckIcon } from 'lucide-react';
import { includes } from '../data/content';
export function IncludesSection() {
  return <section aria-labelledby="incluye" className="border-y border-court-700/60 bg-court-900/40" data-id="element-124" data-mp="2dqrkohovg6ii">
      <div className="mx-auto max-w-5xl px-5 py-14 sm:py-16" style={{
      paddingTop: "13px",
      paddingBottom: "23px"
    }} data-id="element-125" data-mp="28xyerqho2s4u">
        <h2 id="incluye" className="text-center font-display text-2xl uppercase text-white sm:text-3xl" data-id="element-126" data-mp="2406eo96vbzpk">
          Esto lo tienes desde el primer día
        </h2>
        <ul className="mx-auto mt-8 grid max-w-3xl gap-4 sm:grid-cols-2" data-id="element-127" data-mp="1uyoykqtgny0v">
          {includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-128" data-mp="1q1q60cpg3z4s">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-ball-400" data-id="element-129" data-mp="1l1kceqzm82k2">
                <CheckIcon className="h-4 w-4 text-ink-900" aria-hidden="true" strokeWidth={3} data-id="element-130" data-mp="3kf7xubwvvi5m" />
              </span>
              <span className="text-[15px] leading-relaxed text-slate-200" data-id="element-131" data-mp="3fgmwg95wasfl">{item}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}